import axios from 'utils/axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';
import { showSuccessModal } from 'actions';

// --- Common Helpers ---
const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });
const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch) => {
  const res = error?.response;
  if (res?.status === 422) {
    dispatch({ type: types.CONFIGURATIONS_VALIDATION_ERROR, validation_error: res.data.errors });
  } else {
    dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
  }
};

// --- Action Creators ---
export const configurationRedirectToList = () => ({ type: types.CONFIGURATIONS_REDIRECT });

export const hideConfigurationValidationError = (field_key) => ({
  type: types.HIDE_CONFIGURATIONS_FEILD_VALIDATION_ERROR,
  field_key: field_key
});

// A helper to make the first letter of a string uppercase
const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);


// =============================================================
// FETCH LIST
// =============================================================
export const fetchConfigurations = (type, params = {}) => dispatch => {
  dispatch({ type: types.CONFIGURATIONS_REQUEST, configType: type });
  dispatch(loader());

  axios.get(`${API_URL}admin/configurations/${type}`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.CONFIGURATIONS_SUCCESS,
        payload: { type, data: res.data }
      });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch);
    });
};

// =============================================================
// FETCH BY ID
// =============================================================
export const getConfigurationById = (type, id, actionType, object_viewed_id) => dispatch => {
  dispatch({ type: types.CONFIGURATIONS_REQUEST, configType: type });
  dispatch(loader());

  axios.get(`${API_URL}admin/configurations/${type}/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.CONFIGURATIONS_GET_SUCCESS,
        payload: { type, record: res.data, actionType }
      });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch);
    });
};

// =============================================================
// CREATE OR UPDATE
// =============================================================
export const createOrUpdateConfiguration = (type, data, method = 'POST', object_viewed_id) => dispatch => {
  dispatch({ type: types.CONFIGURATIONS_REQUEST, configType: type });
  dispatch(loader());

  const url = method === 'POST'
    ? `${API_URL}admin/configurations/${type}`
    : `${API_URL}admin/configurations/${type}/${data.id}`;

  axios({
    url,
    method,
    data,
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      const successMessage = `${capitalize(type)} ${method === 'POST' ? 'created' : 'updated'} successfully`;
      dispatch(showSuccessModal(successMessage));
      dispatch(configurationRedirectToList());
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch);
    });
};

// =============================================================
// DELETE
// =============================================================
export const deleteConfiguration = (type, id, object_viewed_id) => dispatch => {
  dispatch({ type: types.CONFIGURATIONS_REQUEST, configType: type });
  dispatch(loader());

  axios.delete(`${API_URL}admin/configurations/${type}/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar(`${capitalize(type)} deleted`, 'success'));
      dispatch(fetchConfigurations(type, { object_viewed_id })); // Refetch the list
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch);
    });
};

// =============================================================
// DROPDOWN
// =============================================================
export const fetchConfigurationsDropdown = (type, params) => dispatch => {
  dispatch({ type: types.CONFIGURATIONS_REQUEST, configType: type });
  axios.get(`${API_URL}admin/configurations/${type}/dropdown`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(res => {
      dispatch({
        type: types.CONFIGURATIONS_DROPDOWN_SUCCESS,
        payload: { type, data: res.data }
      });
    })
    .catch(err => {
      handleError(err, dispatch);
    });
};

// =============================================================
// EXPORT
// =============================================================
export const exportConfigurations = (type, extraFilters, object_viewed_id) => dispatch => {
  dispatch(loader('Exporting...'));
  const url = `${API_URL}admin/configurations/${type}/export`;

  axios.post(url, { ...extraFilters, object_viewed_id }, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(response => {
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlBlob;
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${type}.xlsx`; // Dynamic filename
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch?.length > 1)
          filename = filenameMatch[1];
      }
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlBlob);
      dispatch(hideLoader());
    })
    .catch(error => {
      dispatch(hideLoader());
      handleError(error, dispatch);
    });
};